<template>
  <v-dialog
    :value="value"
    v-on:input="$emit('input', $event)"
    persistent
    max-width="460"
  >
    <v-card>
      <v-card-title class="headline justify-center">
        <span>{{ $t("create-teacher-title") }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-4 pb-0">
        <v-row>
          <v-col class="py-0 mt-2">
            <v-row>
              <label for="email">{{ $t("email-address-title") }}</label>
              <v-text-field
                id="email"
                v-model.trim="email"
                class="max-width-3"
                :error-messages="emailErrors"
                @input="$v.email.$touch()"
                @blur="blurTrim"
                required
                :key="emailKey"
                dense
                autofocus
                outlined
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn
          color="primary"
          class="font-weight-bold"
          :loading="loaddingAddTeacher"
          @click="addTeacher"
          >登録</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import { createTeacher } from "@/api/Teacher.api";
export default {
  props: ["value"],
  mixins: [mixin.Auth, mixin.ValidateCreateTeacher],
  data() {
    return {
      username: "",
      email: "",
      emailKey: 0,
      loaddingAddTeacher: false,
    };
  },
  methods: {
    async addTeacher() {
      const { email } = this;
      this.loaddingAddTeacher = true;
      var password = this.generatePassword();
      this.$v.$touch();
      console.log("process.env.VUE_APP_NOTE: ",process.env.VUE_APP_NOTE)
      if (!this.$v.$anyError) {
        await this.handleSignUpUser(email, password, email, "Teacher")
          .then(async (data) => {
            let params = {
              username: data,
              email,
              password,
            };
            await createTeacher(params)
              .then(() => {
                this.$emit("resetList");
              })
              .catch((err) => {
                this.$toast.error(err);
              });
          })
          .catch((err) => {
            const { code } = err;
            if (code == "UsernameExistsException") {
              this.$toast.error("メールアドレスはすでに存在します。");
            }
          });
      }
      this.loaddingAddTeacher = false;
    },
    blurTrim() {
      this.email.trim();
      this.emailKey++;
    },
    generatePassword() {
      let charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < 10; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
</style>